import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfirmationService, MessageService } from 'primeng/api';

import { Evento } from '../models/evento';
import { EventoService } from '../evento.service';



@Component({
  selector: 'app-evento-list',
  templateUrl: './evento-list.component.html',
  styleUrls: ['./evento-list.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EventoListComponent implements OnInit {

  public eventos: Evento[];
  public idEvento: number;
  public evento: Evento;
  public minDate: Date = new Date();
  
  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;
  
  constructor(public eventoService: EventoService,
              private router: Router, 
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  ngOnInit(): void {   
    this.getEventos();    
  }

  getEventos() {
    this.eventoService.getEventos().subscribe(
      (res) => {
        if (res) {
          this.eventos = res;            
        }
      },
      err => {
        console.log("EventoList - Eventos");
        console.log(err);
      }
    );
  } 

  getEvento(idEvento) {

    this.eventoService.getEvento(idEvento).subscribe(
      (res) => {
        if (res) {
          this.evento = res;
        }
      },
      err => {
        console.log("EventoList - Evento");
        console.log(err);
      }
    );
  }
  

  addEvento() {
    this.evento = {};
    this.submitted = false;
    this.displayDialog = true;
  }
  
  updEvento(idEvento: number) {  
    this.router.navigate(['/evento-detalhe',idEvento]);
  }

  dashEvento(idEvento: number) {  
    this.router.navigate(['/dashboard-evento-vendas',idEvento]);
  }

  importarProdutoEvento(idEvento: number, descricao: string) {  
    this.router.navigate(['/importar-produtos',idEvento, descricao]);
  }
  
  delEvento(evento: Evento) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover o Evento: ' + evento.nome + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.eventoService
              .delEvento(evento.idEvento)
              .subscribe(                     
                  () => this.getEventos(),
                  err => console.log(err)
              );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Evento removido com sucesso!', life: 3000});
          }
      });
  }
  
  hideDialog() {
      this.displayDialog = false;
      this.submitted = false;        
  }
  
  saveEvento() {
      this.submitted = true;      
      if (this.evento.nome.trim()) {
          if (this.evento.idEvento) {
            
            this.eventoService
            .updEvento(this.evento)
            .subscribe(                     
                () => this.getEventos(),
                err => console.log(err)
            );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Evento atualizado com sucesso!', life: 3000});
          } else {
             this.eventoService
                 .addEvento(this.evento)
                 .subscribe(                     
                     () => this.getEventos(),
                     err => 
                     {
                        this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                       console.log(err)
                     }
                 );

              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Evento atualizado com sucesso!', life: 3000});
          }
  
          this.eventos = [...this.eventos];
          this.displayDialog = false;
          this.evento = {};
      }
  }
}
